import ShowBulk from './ShowBulk';

export default ShowBulk;
